/**
 * Auction CTA Bar: sticky behaviour + carousel on mobile + CTA badges from API.
 */
(function () {
  'use strict';

  var PAY_NOW_BADGE_REFRESH_EVENT = 'rising-auctions:refresh-pay-now-badge';
  var CTA_BADGE_REFRESH_EVENT = 'rising-auctions:refresh-cta-badges';
  var BADGE_LABELS = {
    payNow: { singular: 'item to pay', plural: 'items to pay' },
    activeBids: { singular: 'active bid', plural: 'active bids' },
    favourites: { singular: 'favourite bid', plural: 'favourite bids' }
  };

  function setBadgeState(badge, key, count) {
    if (!badge) return;
    if (count > 0) {
      var labels = BADGE_LABELS[key] || { singular: 'item', plural: 'items' };
      badge.textContent = String(count);
      badge.removeAttribute('hidden');
      badge.setAttribute('aria-label', count + ' ' + (count === 1 ? labels.singular : labels.plural));
      badge.removeAttribute('aria-hidden');
    } else {
      badge.textContent = '';
      badge.setAttribute('hidden', '');
      badge.setAttribute('aria-hidden', 'true');
      badge.removeAttribute('aria-label');
    }
  }

  function refreshCtaBadges() {
    var nav = document.querySelector('.rising-auctions-cta-bar[data-cta-counts-url][data-cta-counts-customer-id]');
    if (!nav) return;
    var countUrl = nav.getAttribute('data-cta-counts-url');
    var customerId = nav.getAttribute('data-cta-counts-customer-id');
    if (!countUrl || !customerId) return;
    var badges = nav.querySelectorAll('[data-cta-count-badge]');
    if (!badges.length) return;
    var url = countUrl + '?logged_in_customer_id=' + encodeURIComponent(customerId);
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        badges.forEach(function (badge) {
          var key = badge.getAttribute('data-cta-count-badge');
          var count = key && typeof data[key] === 'number' ? data[key] : 0;
          setBadgeState(badge, key, count);
        });
      })
      .catch(function () {
        badges.forEach(function (badge) {
          setBadgeState(badge, badge.getAttribute('data-cta-count-badge'), 0);
        });
      });
  }

  if (document.documentElement.dataset.raCtaBadgeRefreshListener !== 'true') {
    document.documentElement.dataset.raCtaBadgeRefreshListener = 'true';
    document.addEventListener(CTA_BADGE_REFRESH_EVENT, function () {
      refreshCtaBadges();
    });
    document.addEventListener(PAY_NOW_BADGE_REFRESH_EVENT, function () {
      refreshCtaBadges();
    });
  }

  function initCtaBadges() {
    refreshCtaBadges();
  }

  function initSticky() {
    var wrapper = document.querySelector('[data-cta-bar-wrapper][data-cta-bar-sticky]');
    if (!wrapper) return;
    // position: sticky is applied to the parent .shopify-section wrapper with
    // top: -1px, so the stuck bar pokes 1px above the viewport and full
    // visibility (ratio 1) means "not stuck". The shadow is skipped when a
    // fixed header offsets the bar below the viewport top.
    var stickyEl = wrapper.closest('.shopify-section') || wrapper;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var stuck = entry.intersectionRatio < 1 && entry.boundingClientRect.top <= 0;
        wrapper.classList.toggle('is-stuck', stuck);
      });
    }, { threshold: [1] });
    observer.observe(stickyEl);
  }

  function initCtaBarCarousel() {
    var tracks = document.querySelectorAll('[data-cta-bar-track]');
    tracks.forEach(function (track) {
      if (track.dataset.raCtaBarDragInit) return;
      track.dataset.raCtaBarDragInit = 'true';

      var isDragging = false;
      var startX = 0;
      var scrollLeftStart = 0;
      var dragThreshold = 5;

      function getPageX(e) {
        if (e.type.indexOf('touch') === 0) {
          return e.touches[0] ? e.touches[0].pageX : e.changedTouches[0].pageX;
        }
        return e.pageX;
      }

      function onPointerDown(e) {
        startX = getPageX(e);
        scrollLeftStart = track.scrollLeft;
        isDragging = false;
      }

      function onPointerMove(e) {
        if (startX === 0) return;
        var x = getPageX(e);
        if (!isDragging && Math.abs(x - startX) > dragThreshold) {
          isDragging = true;
        }
        if (isDragging) {
          track.scrollLeft = scrollLeftStart + (startX - x);
          e.preventDefault();
        }
      }

      function onPointerUp() {
        startX = 0;
      }

      function onLinkClick(e) {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
        isDragging = false;
      }

      track.addEventListener('mousedown', onPointerDown);
      track.addEventListener('touchstart', onPointerDown, { passive: true });

      document.addEventListener('mousemove', function (e) {
        if (startX && track.contains(document.elementFromPoint(e.clientX, e.clientY))) {
          onPointerMove(e);
        }
      });
      document.addEventListener('mouseup', function () {
        if (startX) onPointerUp();
      });

      track.addEventListener('touchmove', function (e) {
        if (startX) {
          onPointerMove(e);
          if (isDragging) e.preventDefault();
        }
      }, { passive: false });

      track.addEventListener('touchend', onPointerUp);
      track.addEventListener('touchcancel', onPointerUp);

      track.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', onLinkClick, true);
      });
    });
  }

  function init() {
    initSticky();
    initCtaBarCarousel();
    initCtaBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
